/// <reference path="../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {
    "use strict";

    import IDealerwareEmployee = DealerwareWebServices.IDealerwareEmployee;

    export class ConfirmAccountController {
        public static $inject: string[] = [
            '$stateParams',
            '$state',
            '$mdDialog',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$dealerwareEmployeeFactory'
        ];

        public confirmationToken: string;
        public employee: IDealerwareEmployee;

        constructor(public $stateParams: any,
                    public $state: any,
                    public $mdDialog: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $dealerwareEmployeeFactory: any) {
            if (this.$stateParams.confirmation_token) {
                this.loadEmployee(this.$stateParams.confirmation_token);
            }
        }

        public loadEmployee(confirmationToken: string) : void {

            var _self = this;

            var loader = this.$dealerwareLoading.show('Loading...');

            this.$dealerwareEmployeeFactory.loadEmployeeByConfirmationToken(confirmationToken)

                .then( ( response: any ) => {
                    loader.close();
                    _self.employee = response.employee;
                    _self.showModal();
                })

                // This code doesn't do any checking to determine what kind of error we've
                // just received, which is probably for the best since basing UX decisions
                // on HTTP return codes seems kind of brittle to me.
                //
                // That said, the particular error targeted here is a 422 from reclicking
                // the 'Activate Account' button in the account confirmation email.  The account
                // has already been confirmed, so sending the user to login, after providing
                // an explanation modal, is the right thing to do since they should be wanting
                // to log in (with their confirmed account) next anyway.
                //
                // However, this is going to catch any error -- and do the redirect -- 422 or not.
                // Still, I think, bouncing the user to login is probably the best we can do anyway
                // even for whatever backend errors might also get us to this catch.
                //
                .catch( ( response: any ) => {

                    loader.close();

                    _self.$state.go('shortcuts.logout')

                        // To complicate things further, this $state.go will always cause a
                        // 'transition superseded' error from ui-router, though the state change
                        // will work.  Superficially, this error is supposed to be thrown whenever
                        // UI router is asked to change a route when it's already in a route transition.
                        //
                        // However, as near as I can figure, a state change isn't happening when we get
                        // into this block and setting a long $timeout doesn't change the situation.
                        //
                        // It seems to be related to our old versions of angular and angular-ui-router.
                        //
                        //      https://github.com/angular-ui/ui-router/issues/3246
                        //
                        // So, we need to catch the route error but show the error returned by
                        // loadEmployeeByConfirmationToken.  But: if we ever upgrade such that this
                        // erroneous error stops happening, we still need to show the employee factory
                        // error.  Therefore we need a blank .catch and a .finally that opens up the
                        // error modal.
                        //
                        .catch( ( ) => { } )
                        .finally( ( ) => {
                            _self.$dealerwareNotification.apiError(response);
                        });
                })
                .catch( ( response: any ) => {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                });
        }

        public showModal() : void {
            this.$mdDialog.show({
                templateUrl: '/content/confirm_account/set_password_modal.html',
                controller: setPasswordModalController,
                locals: { employee: this.employee },
                parent: angular.element(document.body),
                multiple: true,
                escapeToClose: false,
                clickOutsideToClose: false
            });

            function setPasswordModalController($scope: any,
                                                $state: any,
                                                $mdDialog: any,
                                                UserModel: any,
                                                CurrentUser: any,
                                                $dealerwareNotification: any,
                                                employee: IDealerwareEmployee) {
                $scope.employee = employee;
                $scope.saving = false;

                $scope.savePassword = function() : void {
                    $scope.saving = true;
                    $scope.employee.accountSettings.$setPasswordAndConfirm({ promise: true }).then(
                        function() {
                            $mdDialog.hide();

                            var preLoginSignInCount = $scope.employee.accountSettings.data.sign_in_count;

                            CurrentUser.user = new UserModel({});
                            CurrentUser.login({
                                email: $scope.employee.accountSettings.data.email,
                                password: $scope.employee.accountSettings.data.password,
                                successCallback: function(returnValue: any) {
                                    if ( preLoginSignInCount === 0) {
                                        $mdDialog.show({
                                            templateUrl: '/content/settings/account_activation_success.html',
                                            controller: ( $scope: any ) => {
                                                $scope.close = function() {
                                                    $mdDialog.hide();
                                                }
                                            },
                                            parent: angular.element(document.body),
                                            multiple: true,
                                            clickOutsideToClose: false
                                        });
                                    }

                                    $state.go('shortcuts.dashboard');
                                },
                                errorCallback: function(response: any) { $dealerwareNotification.apiError(response); }
                            });
                        },
                        function(response: any) {
                            $scope.saving = false;
                            $dealerwareNotification.apiError(response);
                        }
                    );
                }
            };
        }
    }

    getDealerwareWebContentModule().controller('ConfirmAccountController', ConfirmAccountController);
}
